export const styles = (theme) => ({
    loginContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: theme.palette.background.default,
        position: 'relative'
    },
    themeToggleContainer: {
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 10
    },
    loginBox: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `0.5px solid ${theme.palette.divider}`,
        width: '50%',
        padding: '3rem',
        borderRadius: '20px',
        boxShadow: theme.palette.mode === 'dark'
            ? 'rgba(0, 0, 0, 0.5) 0px 8px 24px'
            : 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    loginHeader: {
        marginBottom: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatarIcon: {
        width: 72,
        height: 72,
        marginBottom: '0.75rem',
        border: `2px solid ${theme.palette.divider}`,
    },
    brandTitle: {
        fontFamily: theme.brand.fonts.display,
        fontSize: '1.9rem',
        lineHeight: 1.1,
        color: theme.palette.primary.main,
        textAlign: 'center',
    },
    brandSubtitle: {
        fontSize: '0.8rem',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
        textAlign: 'center',
    },
    formContainer: {
        mt: 1,
        width: '100%'
    },
    passwordResetLink: {
        float: 'right',
        fontSize: '0.7rem',
    },
    loginButtonContainer: {
        mt: 3,
        mb: 2,
    },
    loginButton: {
        width: '100%',
    },
    createAccountLinkContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        fontSize: '0.7rem',
        gap: '1px',
        alignItems: 'center'
    },
    createAccountLink: {
        fontSize: '0.7rem',
    },
    link: {
        color: theme.palette.mode === 'dark'
            ? theme.palette.primary.light
            : theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
});